import api from "./api/api";

export const ServiceJornadaFinanceira = {
  getFaturamento: async (id_desk: any) => {
    try {
      const res = await api.get(`/desks/faturamento/getFaturamento/${id_desk}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addFaturamento: async (id_desk: any, payload: any) => {
    try {
      const res = await api.post(
        `/desks/faturamento/addFaturamento/${id_desk}/add`,
        payload,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getMetodosPagamento: async () => {
    try {
      const res = await api.get(`/desks/faturamento/metodo_pagamento`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addMetodosPagamento: async (payload: any) => {
    try {
      const res = await api.post(
        `/desks/faturamento/metodo_pagamento/add`,
        payload,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getContaRecebimento: async () => {
    try {
      const res = await api.get(`/desks/faturamento/conta_recebimento`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addContaRecebimento: async (payload: any) => {
    try {
      const res = await api.post(
        `/desks/faturamento/conta_recebimento/add`,
        payload,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getCondicaoRecebimento: async () => {
    try {
      const res = await api.get(`/desks/faturamento/condicao_recebimento`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addCondicaoRecebimento: async (payload: any) => {
    try {
      const res = await api.post(
        `/desks/faturamento/condicao_recebimento/add`,
        payload,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTipoPagamento: async () => {
    try {
      const res = await api.get(`/desks/faturamento/tipo_pagamento`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  marcarParcelaPaga: async (idParcela: string, payload: { pago: boolean }) => {
    try {
      const res = await api.patch(
        `/desks/faturamento/parcela/${idParcela}/marcar_pago`,
        payload,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};
